import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { useCartStore } from '@entities/Cart'

import { BonusApplier, useBonusManager } from '@features/bonus-control'

import TabsSwitcher from '@widgets/modal-delivery/ui/TabsSwitcher'

import Button from '@shared/ui/button'
import Input from '@shared/ui/input'

import styles from './styles.module.scss'

export default function DiscountControl () {
  const { t } = useTranslation('cart')
  const [ activeTab, setActiveTab ] = useState<'promo' | 'bonuses'>('promo')
  const [ promoCodeInput, setPromocodeInput ] = useState('')
  const { setPromocode } = useCartStore()
  const bonusManager = useBonusManager()

  const tabs = [
    {
      label: t('discount.promocodes'),
      value: 'promo',
    },
    {
      label: t('discount.bonuses'),
      value: 'bonuses',
      badge: bonusManager.hasAppliedBonuses ? '1' : undefined,
    },
  ]

  const handleApplyPromo = () => {
    if (promoCodeInput) {
      setPromocode(promoCodeInput)
    }
  }

  return (
    <div className={styles.root}>
      <TabsSwitcher
        tabs={tabs}
        active={activeTab}
        onChange={(value) => setActiveTab(value as 'promo' | 'bonuses')}
        className={styles.tabs}
      />

      {activeTab === 'promo' && (
        <div className={styles.promo}>
          <div className={styles.promo__input}>
            <Input
              value={promoCodeInput}
              onChange={(e) => setPromocodeInput(e.target.value)}
              placeholder={t('discount.enter_promocode')}
              inputSize="large"
              className={styles.promo__field}
            />
            <Button className={styles.promo__button} onClick={handleApplyPromo}>
              <ReactSVG src="/icons/arrow-right.svg" />
            </Button>
          </div>
        </div>
      )}

      {activeTab === 'bonuses' && (
        <div className={styles.bonus}>
          <BonusApplier
            onApplyBonuses={bonusManager.applyBonuses}
            onClearBonuses={bonusManager.clearBonuses}
          />
        </div>
      )}
    </div>
  )
}
